import { Injectable, inject } from '@angular/core';

import { ProductV2Category } from '../../core/models/product-v2.model';

import { CategoryHelperService } from './category-helper.service';


@Injectable({
  providedIn: 'root'
})
export class CategoryIconMapperService {
  private categoryHelper = inject(CategoryHelperService);

  
  mapProductToIconCategory(categories: ProductV2Category[], productType?: string): string {
    const categoryNames = (categories || []).map(cat => cat.name.toLowerCase());
    
    if (categoryNames.some(name => name.includes('colaboração') || name.includes('produtividade'))) {
      return 'office'; 
    } else if (categoryNames.some(name => name.includes('segurança'))) {
      return 'security'; 
    } else if (categoryNames.some(name => name.includes('presença') || name.includes('digital'))) {
      return 'digitalPresence'; 
    } else if (categoryNames.some(name => name.includes('gestão') || name.includes('benefícios') || name.includes('empresariais'))) {
      return 'business'; 
    } else if (categoryNames.some(name => name.includes('cloud'))) {
      return 'cloud'; 
    } else if (categoryNames.some(name => name.includes('microsoft'))) {
      return 'business'; 
    } else {
      const categoryMapping: Record<string, string> = {
        'sharing': 'office',             
        'security': 'security',         
        'hardware': 'digitalPresence',    
        'service': 'business',            
        'office': 'office',              
        // 'cloud': 'cloud'                 
      };
      const categoryKey = productType || 'service';
      return categoryMapping[categoryKey] || 'business';
    }
  }

  mapProductToIcon(categories: ProductV2Category[], productType?: string): { name: string; type: 'mondrian-icons' } {
    const iconCategory = this.mapProductToIconCategory(categories, productType);
    
    const iconMapping: Record<string, string> = {
      'office': 'cafe',
      'security': 'escudo-pessoas',
      'digitalPresence': 'celular',
      'business': 'mala-mao',
      'cloud': 'nuvem'
    };

    return {
      name: iconMapping[iconCategory] || 'engrenagem',
      type: 'mondrian-icons'
    };
  }

  mapCategoryUuidToIconCategory(uuid?: string): string {
    return this.categoryHelper.mapUuidToKey(uuid);
  }
} 